export const DEFAULT_PLACEHOLDER = "Type cooking requests";
export const DEBOUNCE_TIMEOUT = 1000;
export const COOKING_REQUESTS = "Cooking requests";
export const SAVE = "Save";
export const EDIT_COOKING_REQUESTS = "Edit cooking requests";
